import React, { Component } from 'react';
import {
  Image,
} from '..';

class AboutPhotoCol extends Component {
  render() {
    const {
      personalPortrait,
      portraitTimestamp,
      portraitCaption,
      photographyShowcase,
    } = this.props;
    return (
      <div className="col col-left photos-col photos--desktop">
        <div className="photos-container">
          <div className="portrait-photo photo">
            <Image image={personalPortrait} className="cover" />
            <div className="subtitle subtitle-right">
              <div className="subtitle-container has-dot">
                <span>About Me</span>
              </div>
            </div>
            <div className="subtitle subtitle-left">
              <div className="subtitle-container">
                <span>{portraitCaption.text}</span>
              </div>
              <div className="subtitle-container">
                <span>{portraitTimestamp}</span>
              </div>
            </div>
          </div>
          {photographyShowcase && photographyShowcase.map((photo, index) => {
            const {
              featuredPhoto,
              photoOrientation,
              caption,
            } = photo;
            const isEven = Boolean(index % 2 === 0);
            return (
              <div className={`showcase-photo photo ${photoOrientation.toLowerCase()}`} key={featuredPhoto.localFile.id}>
                <Image image={featuredPhoto} className="cover" />
                <div className={`subtitle ${isEven ? 'subtitle-right' : 'subtitle-left'}`}>
                  <div className="subtitle-container">
                    {caption.text && <span>{caption.text}</span>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default AboutPhotoCol;
